var map = {
	"./audio.svg": "5a66",
	"./challenge.svg": "da60",
	"./coaching.svg": "e4e1",
	"./interaction.svg": "7e26",
	"./participation.svg": "69da",
	"./reading.svg": "708c",
	"./watching.svg": "c7f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c07f";